import React from 'react'
import styled from 'styled-components'

const Blog = () => {
  return (
    <Wrapper>
      <h2>Blog</h2>
      <p>Arrivera bientôt...</p>
    </Wrapper>
  )
}

export default Blog
const Wrapper = styled.section`
  padding: 6rem;
  p {
    margin: 0 auto;
  }
`
